import ADRegionImage from '../assets/graphics/png/settings/region/region_AD.png';
import AERegionImage from '../assets/graphics/png/settings/region/region_AE.png';
import AFRegionImage from '../assets/graphics/png/settings/region/region_AF.png';
import AGRegionImage from '../assets/graphics/png/settings/region/region_AG.png';
import AIRegionImage from '../assets/graphics/png/settings/region/region_AI.png';
import ALRegionImage from '../assets/graphics/png/settings/region/region_AL.png';
import AMRegionImage from '../assets/graphics/png/settings/region/region_AM.png';
import ANRegionImage from '../assets/graphics/png/settings/region/region_AN.png';
import AORegionImage from '../assets/graphics/png/settings/region/region_AO.png';
import AQRegionImage from '../assets/graphics/png/settings/region/region_AQ.png';
import ARRegionImage from '../assets/graphics/png/settings/region/region_AR.png';
import ASRegionImage from '../assets/graphics/png/settings/region/region_AS.png';
import ATRegionImage from '../assets/graphics/png/settings/region/region_AT.png';
import AURegionImage from '../assets/graphics/png/settings/region/region_AU.png';
import AWRegionImage from '../assets/graphics/png/settings/region/region_AW.png';
import AXRegionImage from '../assets/graphics/png/settings/region/region_AX.png';
import AZRegionImage from '../assets/graphics/png/settings/region/region_AZ.png';
import BARegionImage from '../assets/graphics/png/settings/region/region_BA.png';
import BBRegionImage from '../assets/graphics/png/settings/region/region_BB.png';
import BDRegionImage from '../assets/graphics/png/settings/region/region_BD.png';
import BERegionImage from '../assets/graphics/png/settings/region/region_BE.png';
import BFRegionImage from '../assets/graphics/png/settings/region/region_BF.png';
import BGRegionImage from '../assets/graphics/png/settings/region/region_BG.png';
import BHRegionImage from '../assets/graphics/png/settings/region/region_BH.png';
import BIRegionImage from '../assets/graphics/png/settings/region/region_BI.png';
import BJRegionImage from '../assets/graphics/png/settings/region/region_BJ.png';
import BLRegionImage from '../assets/graphics/png/settings/region/region_BL.png';
import BMRegionImage from '../assets/graphics/png/settings/region/region_BM.png';
import BNRegionImage from '../assets/graphics/png/settings/region/region_BN.png';
import BORegionImage from '../assets/graphics/png/settings/region/region_BO.png';
import BRRegionImage from '../assets/graphics/png/settings/region/region_BR.png';
import BSRegionImage from '../assets/graphics/png/settings/region/region_BS.png';
import BTRegionImage from '../assets/graphics/png/settings/region/region_BT.png';
import BWRegionImage from '../assets/graphics/png/settings/region/region_BW.png';
import BYRegionImage from '../assets/graphics/png/settings/region/region_BY.png';
import BZRegionImage from '../assets/graphics/png/settings/region/region_BZ.png';
import CARegionImage from '../assets/graphics/png/settings/region/region_CA.png';
import CCRegionImage from '../assets/graphics/png/settings/region/region_CC.png';
import CDRegionImage from '../assets/graphics/png/settings/region/region_CD.png';
import CFRegionImage from '../assets/graphics/png/settings/region/region_CF.png';
import CGRegionImage from '../assets/graphics/png/settings/region/region_CG.png';
import CHRegionImage from '../assets/graphics/png/settings/region/region_CH.png';
import CIRegionImage from '../assets/graphics/png/settings/region/region_CI.png';
import CKRegionImage from '../assets/graphics/png/settings/region/region_CK.png';
import CLRegionImage from '../assets/graphics/png/settings/region/region_CL.png';
import CMRegionImage from '../assets/graphics/png/settings/region/region_CM.png';
import CNRegionImage from '../assets/graphics/png/settings/region/region_CN.png';
import CORegionImage from '../assets/graphics/png/settings/region/region_CO.png';
import CRRegionImage from '../assets/graphics/png/settings/region/region_CR.png';
import CURegionImage from '../assets/graphics/png/settings/region/region_CU.png';
import CVRegionImage from '../assets/graphics/png/settings/region/region_CV.png';
import CWRegionImage from '../assets/graphics/png/settings/region/region_CW.png';
import CXRegionImage from '../assets/graphics/png/settings/region/region_CX.png';
import CYRegionImage from '../assets/graphics/png/settings/region/region_CY.png';
import CZRegionImage from '../assets/graphics/png/settings/region/region_CZ.png';
import DERegionImage from '../assets/graphics/png/settings/region/region_DE.png';
import DJRegionImage from '../assets/graphics/png/settings/region/region_DJ.png';
import DKRegionImage from '../assets/graphics/png/settings/region/region_DK.png';
import DMRegionImage from '../assets/graphics/png/settings/region/region_DM.png';
import DORegionImage from '../assets/graphics/png/settings/region/region_DO.png';
import DZRegionImage from '../assets/graphics/png/settings/region/region_DZ.png';
import ECRegionImage from '../assets/graphics/png/settings/region/region_EC.png';
import EERegionImage from '../assets/graphics/png/settings/region/region_EE.png';
import EGRegionImage from '../assets/graphics/png/settings/region/region_EG.png';
import EHRegionImage from '../assets/graphics/png/settings/region/region_EH.png';
import ERRegionImage from '../assets/graphics/png/settings/region/region_ER.png';
import ESRegionImage from '../assets/graphics/png/settings/region/region_ES.png';
import ETRegionImage from '../assets/graphics/png/settings/region/region_ET.png';
import EURegionImage from '../assets/graphics/png/settings/region/region_EU.png';
import FIRegionImage from '../assets/graphics/png/settings/region/region_FI.png';
import FJRegionImage from '../assets/graphics/png/settings/region/region_FJ.png';
import FKRegionImage from '../assets/graphics/png/settings/region/region_FK.png';
import FMRegionImage from '../assets/graphics/png/settings/region/region_FM.png';
import FORegionImage from '../assets/graphics/png/settings/region/region_FO.png';
import FRRegionImage from '../assets/graphics/png/settings/region/region_FR.png';
import GARegionImage from '../assets/graphics/png/settings/region/region_GA.png';
import GBRegionImage from '../assets/graphics/png/settings/region/region_GB.png';
import GDRegionImage from '../assets/graphics/png/settings/region/region_GD.png';
import GERegionImage from '../assets/graphics/png/settings/region/region_GE.png';
import GGRegionImage from '../assets/graphics/png/settings/region/region_GG.png';
import GHRegionImage from '../assets/graphics/png/settings/region/region_GH.png';
import GIRegionImage from '../assets/graphics/png/settings/region/region_GI.png';
import GLRegionImage from '../assets/graphics/png/settings/region/region_GL.png';
import GMRegionImage from '../assets/graphics/png/settings/region/region_GM.png';
import GNRegionImage from '../assets/graphics/png/settings/region/region_GN.png';
import GQRegionImage from '../assets/graphics/png/settings/region/region_GQ.png';
import GRRegionImage from '../assets/graphics/png/settings/region/region_GR.png';
import GSRegionImage from '../assets/graphics/png/settings/region/region_GS.png';
import GTRegionImage from '../assets/graphics/png/settings/region/region_GT.png';
import GURegionImage from '../assets/graphics/png/settings/region/region_GU.png';
import GWRegionImage from '../assets/graphics/png/settings/region/region_GW.png';
import GYRegionImage from '../assets/graphics/png/settings/region/region_GY.png';
import HKRegionImage from '../assets/graphics/png/settings/region/region_HK.png';
import HNRegionImage from '../assets/graphics/png/settings/region/region_HN.png';
import HRRegionImage from '../assets/graphics/png/settings/region/region_HR.png';
import HTRegionImage from '../assets/graphics/png/settings/region/region_HT.png';
import HURegionImage from '../assets/graphics/png/settings/region/region_HU.png';
import IDRegionImage from '../assets/graphics/png/settings/region/region_ID.png';
import IERegionImage from '../assets/graphics/png/settings/region/region_IE.png';
import ILRegionImage from '../assets/graphics/png/settings/region/region_IL.png';
import IMRegionImage from '../assets/graphics/png/settings/region/region_IM.png';
import INRegionImage from '../assets/graphics/png/settings/region/region_IN.png';
import IQRegionImage from '../assets/graphics/png/settings/region/region_IQ.png';
import IRRegionImage from '../assets/graphics/png/settings/region/region_IR.png';
import ISRegionImage from '../assets/graphics/png/settings/region/region_IS.png';
import ITRegionImage from '../assets/graphics/png/settings/region/region_IT.png';
import JERegionImage from '../assets/graphics/png/settings/region/region_JE.png';
import JMRegionImage from '../assets/graphics/png/settings/region/region_JM.png';
import JORegionImage from '../assets/graphics/png/settings/region/region_JO.png';
import JPRegionImage from '../assets/graphics/png/settings/region/region_JP.png';
import KERegionImage from '../assets/graphics/png/settings/region/region_KE.png';
import KGRegionImage from '../assets/graphics/png/settings/region/region_KG.png';
import KHRegionImage from '../assets/graphics/png/settings/region/region_KH.png';
import KIRegionImage from '../assets/graphics/png/settings/region/region_KI.png';
import KMRegionImage from '../assets/graphics/png/settings/region/region_KM.png';
import KNRegionImage from '../assets/graphics/png/settings/region/region_KN.png';
import KPRegionImage from '../assets/graphics/png/settings/region/region_KP.png';
import KRRegionImage from '../assets/graphics/png/settings/region/region_KR.png';
import KWRegionImage from '../assets/graphics/png/settings/region/region_KW.png';
import KYRegionImage from '../assets/graphics/png/settings/region/region_KY.png';
import KZRegionImage from '../assets/graphics/png/settings/region/region_KZ.png';
import LARegionImage from '../assets/graphics/png/settings/region/region_LA.png';
import LBRegionImage from '../assets/graphics/png/settings/region/region_LB.png';
import LCRegionImage from '../assets/graphics/png/settings/region/region_LC.png';
import LIRegionImage from '../assets/graphics/png/settings/region/region_LI.png';
import LKRegionImage from '../assets/graphics/png/settings/region/region_LK.png';
import LRRegionImage from '../assets/graphics/png/settings/region/region_LR.png';
import LSRegionImage from '../assets/graphics/png/settings/region/region_LS.png';
import LTRegionImage from '../assets/graphics/png/settings/region/region_LT.png';
import LURegionImage from '../assets/graphics/png/settings/region/region_LU.png';
import LVRegionImage from '../assets/graphics/png/settings/region/region_LV.png';
import LYRegionImage from '../assets/graphics/png/settings/region/region_LY.png';
import MARegionImage from '../assets/graphics/png/settings/region/region_MA.png';
import MCRegionImage from '../assets/graphics/png/settings/region/region_MC.png';
import MDRegionImage from '../assets/graphics/png/settings/region/region_MD.png';
import MERegionImage from '../assets/graphics/png/settings/region/region_ME.png';
import MFRegionImage from '../assets/graphics/png/settings/region/region_MF.png';
import MGRegionImage from '../assets/graphics/png/settings/region/region_MG.png';
import MHRegionImage from '../assets/graphics/png/settings/region/region_MH.png';
import MKRegionImage from '../assets/graphics/png/settings/region/region_MK.png';
import MLRegionImage from '../assets/graphics/png/settings/region/region_ML.png';
import MMRegionImage from '../assets/graphics/png/settings/region/region_MM.png';
import MNRegionImage from '../assets/graphics/png/settings/region/region_MN.png';
import MORegionImage from '../assets/graphics/png/settings/region/region_MO.png';
import MPRegionImage from '../assets/graphics/png/settings/region/region_MP.png';
import MQRegionImage from '../assets/graphics/png/settings/region/region_MQ.png';
import MRRegionImage from '../assets/graphics/png/settings/region/region_MR.png';
import MSRegionImage from '../assets/graphics/png/settings/region/region_MS.png';
import MTRegionImage from '../assets/graphics/png/settings/region/region_MT.png';
import MURegionImage from '../assets/graphics/png/settings/region/region_MU.png';
import MVRegionImage from '../assets/graphics/png/settings/region/region_MV.png';
import MWRegionImage from '../assets/graphics/png/settings/region/region_MW.png';
import MXRegionImage from '../assets/graphics/png/settings/region/region_MX.png';
import MYRegionImage from '../assets/graphics/png/settings/region/region_MY.png';
import MZRegionImage from '../assets/graphics/png/settings/region/region_MZ.png';
import NARegionImage from '../assets/graphics/png/settings/region/region_NA.png';
import NCRegionImage from '../assets/graphics/png/settings/region/region_NC.png';
import NERegionImage from '../assets/graphics/png/settings/region/region_NE.png';
import NFRegionImage from '../assets/graphics/png/settings/region/region_NF.png';
import NGRegionImage from '../assets/graphics/png/settings/region/region_NG.png';
import NIRegionImage from '../assets/graphics/png/settings/region/region_NI.png';
import NLRegionImage from '../assets/graphics/png/settings/region/region_NL.png';
import NORegionImage from '../assets/graphics/png/settings/region/region_NO.png';
import NPRegionImage from '../assets/graphics/png/settings/region/region_NP.png';
import NRRegionImage from '../assets/graphics/png/settings/region/region_NR.png';
import NURegionImage from '../assets/graphics/png/settings/region/region_NU.png';
import NZRegionImage from '../assets/graphics/png/settings/region/region_NZ.png';
import OMRegionImage from '../assets/graphics/png/settings/region/region_OM.png';
import PARegionImage from '../assets/graphics/png/settings/region/region_PA.png';
import PERegionImage from '../assets/graphics/png/settings/region/region_PE.png';
import PFRegionImage from '../assets/graphics/png/settings/region/region_PF.png';
import PGRegionImage from '../assets/graphics/png/settings/region/region_PG.png';
import PHRegionImage from '../assets/graphics/png/settings/region/region_PH.png';
import PKRegionImage from '../assets/graphics/png/settings/region/region_PK.png';
import PLRegionImage from '../assets/graphics/png/settings/region/region_PL.png';
import PNRegionImage from '../assets/graphics/png/settings/region/region_PN.png';
import PRRegionImage from '../assets/graphics/png/settings/region/region_PR.png';
import PSRegionImage from '../assets/graphics/png/settings/region/region_PS.png';
import PTRegionImage from '../assets/graphics/png/settings/region/region_PT.png';
import PWRegionImage from '../assets/graphics/png/settings/region/region_PW.png';
import PYRegionImage from '../assets/graphics/png/settings/region/region_PY.png';
import QARegionImage from '../assets/graphics/png/settings/region/region_QA.png';
import RORegionImage from '../assets/graphics/png/settings/region/region_RO.png';
import RSRegionImage from '../assets/graphics/png/settings/region/region_RS.png';
import RURegionImage from '../assets/graphics/png/settings/region/region_RU.png';
import RWRegionImage from '../assets/graphics/png/settings/region/region_RW.png';
import SARegionImage from '../assets/graphics/png/settings/region/region_SA.png';
import SBRegionImage from '../assets/graphics/png/settings/region/region_SB.png';
import SCRegionImage from '../assets/graphics/png/settings/region/region_SC.png';
import SDRegionImage from '../assets/graphics/png/settings/region/region_SD.png';
import SERegionImage from '../assets/graphics/png/settings/region/region_SE.png';
import SGRegionImage from '../assets/graphics/png/settings/region/region_SG.png';
import SHRegionImage from '../assets/graphics/png/settings/region/region_SH.png';
import SIRegionImage from '../assets/graphics/png/settings/region/region_SI.png';
import SKRegionImage from '../assets/graphics/png/settings/region/region_SK.png';
import SLRegionImage from '../assets/graphics/png/settings/region/region_SL.png';
import SMRegionImage from '../assets/graphics/png/settings/region/region_SM.png';
import SNRegionImage from '../assets/graphics/png/settings/region/region_SN.png';
import SORegionImage from '../assets/graphics/png/settings/region/region_SO.png';
import SRRegionImage from '../assets/graphics/png/settings/region/region_SR.png';
import SSRegionImage from '../assets/graphics/png/settings/region/region_SS.png';
import STRegionImage from '../assets/graphics/png/settings/region/region_ST.png';
import SVRegionImage from '../assets/graphics/png/settings/region/region_SV.png';
import SYRegionImage from '../assets/graphics/png/settings/region/region_SY.png';
import SZRegionImage from '../assets/graphics/png/settings/region/region_SZ.png';
import TCRegionImage from '../assets/graphics/png/settings/region/region_TC.png';
import TDRegionImage from '../assets/graphics/png/settings/region/region_TD.png';
import TFRegionImage from '../assets/graphics/png/settings/region/region_TF.png';
import TGRegionImage from '../assets/graphics/png/settings/region/region_TG.png';
import THRegionImage from '../assets/graphics/png/settings/region/region_TH.png';
import TJRegionImage from '../assets/graphics/png/settings/region/region_TJ.png';
import TKRegionImage from '../assets/graphics/png/settings/region/region_TK.png';
import TLRegionImage from '../assets/graphics/png/settings/region/region_TL.png';
import TMRegionImage from '../assets/graphics/png/settings/region/region_TM.png';
import TNRegionImage from '../assets/graphics/png/settings/region/region_TN.png';
import TORegionImage from '../assets/graphics/png/settings/region/region_TO.png';
import TRRegionImage from '../assets/graphics/png/settings/region/region_TR.png';
import TTRegionImage from '../assets/graphics/png/settings/region/region_TT.png';
import TVRegionImage from '../assets/graphics/png/settings/region/region_TV.png';
import TWRegionImage from '../assets/graphics/png/settings/region/region_TW.png';
import TZRegionImage from '../assets/graphics/png/settings/region/region_TZ.png';
import UARegionImage from '../assets/graphics/png/settings/region/region_UA.png';
import UGRegionImage from '../assets/graphics/png/settings/region/region_UG.png';
import USRegionImage from '../assets/graphics/png/settings/region/region_US.png';
import UYRegionImage from '../assets/graphics/png/settings/region/region_UY.png';
import UZRegionImage from '../assets/graphics/png/settings/region/region_UZ.png';
import VARegionImage from '../assets/graphics/png/settings/region/region_VA.png';
import VCRegionImage from '../assets/graphics/png/settings/region/region_VC.png';
import VERegionImage from '../assets/graphics/png/settings/region/region_VE.png';
import VGRegionImage from '../assets/graphics/png/settings/region/region_VG.png';
import VIRegionImage from '../assets/graphics/png/settings/region/region_VI.png';
import VNRegionImage from '../assets/graphics/png/settings/region/region_VN.png';
import VURegionImage from '../assets/graphics/png/settings/region/region_VU.png';
import WFRegionImage from '../assets/graphics/png/settings/region/region_WF.png';
import WSRegionImage from '../assets/graphics/png/settings/region/region_WS.png';
import XKRegionImage from '../assets/graphics/png/settings/region/region_XK.png';
import YERegionImage from '../assets/graphics/png/settings/region/region_YE.png';
import YTRegionImage from '../assets/graphics/png/settings/region/region_YT.png';
import ZARegionImage from '../assets/graphics/png/settings/region/region_ZA.png';
import ZMRegionImage from '../assets/graphics/png/settings/region/region_ZM.png';
import ZWRegionImage from '../assets/graphics/png/settings/region/region_ZW.png';
import WorldWideRegionImage from '../assets/graphics/png/settings/region/cloud_icon_region_worldwide_2x.png';

export const WorldwideCode = 'worldwide';

export enum ContinentCode {
  NA = 'NorthAmerica',
  EU = 'Europe',
  AS = 'Asia',
  OC = 'Oceania',
  SA = 'SouthAmerica',
  AF = 'Africa',
  AN = 'Antaractica',
}

export function getRegionInfo(regionCode: RegionsCode | null | undefined) {
  if (!regionCode) {
    return {
      country: 'Unknown',
      image: null,
    };
  }

  const region = Regions.find((r) => r.id === regionCode);

  if (region) {
    return {
      country: region.country || 'Unknown',
      image: region.image,
    };
  } else {
    return {
      country: 'Unknown',
      image: null,
    };
  }
}

export function getRegionPhoneCode(regionCode: RegionsCode | null | undefined) {
  if (!regionCode) {
    return '';
  }
  const region = Regions.find((r) => r.id === regionCode);
  if (region) {
    return region.countryCodes;
  } else {
    return '';
  }
}

export enum RegionsCode {
  AD = 'AD',
  AE = 'AE',
  AF = 'AF',
  AG = 'AG',
  AI = 'AI',
  AL = 'AL',
  AM = 'AM',
  AN = 'AN',
  AO = 'AO',
  AQ = 'AQ',
  AR = 'AR',
  AS = 'AS',
  AT = 'AT',
  AU = 'AU',
  AW = 'AW',
  AX = 'AX',
  AZ = 'AZ',
  BA = 'BA',
  BB = 'BB',
  BD = 'BD',
  BE = 'BE',
  BF = 'BF',
  BG = 'BG',
  BH = 'BH',
  BI = 'BI',
  BJ = 'BJ',
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BR = 'BR',
  BS = 'BS',
  BT = 'BT',
  BW = 'BW',
  BY = 'BY',
  BZ = 'BZ',
  CA = 'CA',
  CC = 'CC',
  CD = 'CD',
  CF = 'CF',
  CG = 'CG',
  CH = 'CH',
  CI = 'CI',
  CK = 'CK',
  CL = 'CL',
  CM = 'CM',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CU = 'CU',
  CV = 'CV',
  CW = 'CW',
  CX = 'CX',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DJ = 'DJ',
  DK = 'DK',
  DM = 'DM',
  DO = 'DO',
  DZ = 'DZ',
  EC = 'EC',
  EE = 'EE',
  EG = 'EG',
  EH = 'EH',
  ER = 'ER',
  ES = 'ES',
  ET = 'ET',
  EU = 'EU',
  FI = 'FI',
  FJ = 'FJ',
  FK = 'FK',
  FM = 'FM',
  FO = 'FO',
  FR = 'FR',
  GA = 'GA',
  GB = 'GB',
  GD = 'GD',
  GE = 'GE',
  GG = 'GG',
  GH = 'GH',
  GI = 'GI',
  GL = 'GL',
  GM = 'GM',
  GN = 'GN',
  GQ = 'GQ',
  GR = 'GR',
  GS = 'GS',
  GT = 'GT',
  GU = 'GU',
  GW = 'GW',
  GY = 'GY',
  HK = 'HK',
  HN = 'HN',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IE = 'IE',
  IL = 'IL',
  IM = 'IM',
  IN = 'IN',
  IQ = 'IQ',
  IR = 'IR',
  IS = 'IS',
  IT = 'IT',
  JE = 'JE',
  JM = 'JM',
  JO = 'JO',
  JP = 'JP',
  KE = 'KE',
  KG = 'KG',
  KH = 'KH',
  KI = 'KI',
  KM = 'KM',
  KN = 'KN',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KY = 'KY',
  KZ = 'KZ',
  LA = 'LA',
  LB = 'LB',
  LC = 'LC',
  LI = 'LI',
  LK = 'LK',
  LR = 'LR',
  LS = 'LS',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  LY = 'LY',
  MA = 'MA',
  MC = 'MC',
  MD = 'MD',
  ME = 'ME',
  MF = 'MF',
  MG = 'MG',
  MH = 'MH',
  MK = 'MK',
  ML = 'ML',
  MM = 'MM',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MQ = 'MQ',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MU = 'MU',
  MV = 'MV',
  MW = 'MW',
  MX = 'MX',
  MY = 'MY',
  MZ = 'MZ',
  NA = 'NA',
  NC = 'NC',
  NE = 'NE',
  NF = 'NF',
  NG = 'NG',
  NI = 'NI',
  NL = 'NL',
  NO = 'NO',
  NP = 'NP',
  NR = 'NR',
  NU = 'NU',
  NZ = 'NZ',
  OM = 'OM',
  PA = 'PA',
  PE = 'PE',
  PF = 'PF',
  PG = 'PG',
  PH = 'PH',
  PK = 'PK',
  PL = 'PL',
  PN = 'PN',
  PR = 'PR',
  PS = 'PS',
  PT = 'PT',
  PW = 'PW',
  PY = 'PY',
  QA = 'QA',
  RO = 'RO',
  RS = 'RS',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SB = 'SB',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SV = 'SV',
  SY = 'SY',
  SZ = 'SZ',
  TC = 'TC',
  TD = 'TD',
  TF = 'TF',
  TG = 'TG',
  TH = 'TH',
  TJ = 'TJ',
  TK = 'TK',
  TL = 'TL',
  TM = 'TM',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TT = 'TT',
  TV = 'TV',
  TW = 'TW',
  TZ = 'TZ',
  UA = 'UA',
  UG = 'UG',
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VA = 'VA',
  VC = 'VC',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  VN = 'VN',
  VU = 'VU',
  WF = 'WF',
  WS = 'WS',
  XK = 'XK',
  YE = 'YE',
  YT = 'YT',
  ZA = 'ZA',
  ZM = 'ZM',
  ZW = 'ZW',
}

export enum RegionsIsoCode3 {
  AND = 'AND',
  ARE = 'ARE',
  AFG = 'AFG',
  ATG = 'ATG',
  AIA = 'AIA',
  ALB = 'ALB',
  ARM = 'ARM',
  ANT = 'ANT',
  AGO = 'AGO',
  ATA = 'ATA',
  ARG = 'ARG',
  ASM = 'ASM',
  AUT = 'AUT',
  AUS = 'AUS',
  ABW = 'ABW',
  AZE = 'AZE',
  BIH = 'BIH',
  BRB = 'BRB',
  BGD = 'BGD',
  BEL = 'BEL',
  BFA = 'BFA',
  BGR = 'BGR',
  BHR = 'BHR',
  BDI = 'BDI',
  BEN = 'BEN',
  BLM = 'BLM',
  BMU = 'BMU',
  BRN = 'BRN',
  BOL = 'BOL',
  BRA = 'BRA',
  BHS = 'BHS',
  BTN = 'BTN',
  BWA = 'BWA',
  BLR = 'BLR',
  BLZ = 'BLZ',
  CAN = 'CAN',
  CCK = 'CCK',
  COD = 'COD',
  CAF = 'CAF',
  COG = 'COG',
  CHE = 'CHE',
  CIV = 'CIV',
  COK = 'COK',
  CHL = 'CHL',
  CMR = 'CMR',
  CHN = 'CHN',
  COL = 'COL',
  CRI = 'CRI',
  CUB = 'CUB',
  CPV = 'CPV',
  CUW = 'CUW',
  CXR = 'CXR',
  CYP = 'CYP',
  CZE = 'CZE',
  DEU = 'DEU',
  DJI = 'DJI',
  DNK = 'DNK',
  DMA = 'DMA',
  DOM = 'DOM',
  DZA = 'DZA',
  ECU = 'ECU',
  EST = 'EST',
  EGY = 'EGY',
  ESH = 'ESH',
  ERI = 'ERI',
  ESP = 'ESP',
  ETH = 'ETH',
  FIN = 'FIN',
  FJI = 'FJI',
  FLK = 'FLK',
  FSM = 'FSM',
  FRO = 'FRO',
  FRA = 'FRA',
  GAB = 'GAB',
  GBR = 'GBR',
  GRD = 'GRD',
  GEO = 'GEO',
  GGY = 'GGY',
  GHA = 'GHA',
  GIB = 'GIB',
  GRL = 'GRL',
  GMB = 'GMB',
  GIN = 'GIN',
  GNQ = 'GNQ',
  GRC = 'GRC',
  GTM = 'GTM',
  GUM = 'GUM',
  GNB = 'GNB',
  GUY = 'GUY',
  HKG = 'HKG',
  HND = 'HND',
  HRV = 'HRV',
  HTI = 'HTI',
  HUN = 'HUN',
  IDN = 'IDN',
  IRL = 'IRL',
  ISR = 'ISR',
  IMN = 'IMN',
  IND = 'IND',
  IRQ = 'IRQ',
  IRN = 'IRN',
  ISL = 'ISL',
  ITA = 'ITA',
  JEY = 'JEY',
  JAM = 'JAM',
  JOR = 'JOR',
  JPN = 'JPN',
  KEN = 'KEN',
  KGZ = 'KGZ',
  KHM = 'KHM',
  KIR = 'KIR',
  COM = 'COM',
  KNA = 'KNA',
  PRK = 'PRK',
  KOR = 'KOR',
  KWT = 'KWT',
  CYM = 'CYM',
  KAZ = 'KAZ',
  LAO = 'LAO',
  LBN = 'LBN',
  LCA = 'LCA',
  LIE = 'LIE',
  LKA = 'LKA',
  LBR = 'LBR',
  LSO = 'LSO',
  LTU = 'LTU',
  LUX = 'LUX',
  LVA = 'LVA',
  LBY = 'LBY',
  MAR = 'MAR',
  MCO = 'MCO',
  MDA = 'MDA',
  MNE = 'MNE',
  MAF = 'MAF',
  MDG = 'MDG',
  MHL = 'MHL',
  MKD = 'MKD',
  MLI = 'MLI',
  MMR = 'MMR',
  MNG = 'MNG',
  MAC = 'MAC',
  MNP = 'MNP',
  MRT = 'MRT',
  MSR = 'MSR',
  MLT = 'MLT',
  MUS = 'MUS',
  MDV = 'MDV',
  MWI = 'MWI',
  MEX = 'MEX',
  MYS = 'MYS',
  MOZ = 'MOZ',
  NAM = 'NAM',
  NCL = 'NCL',
  NER = 'NER',
  NGA = 'NGA',
  NIC = 'NIC',
  NLD = 'NLD',
  NOR = 'NOR',
  NPL = 'NPL',
  NRU = 'NRU',
  NIU = 'NIU',
  NZL = 'NZL',
  OMN = 'OMN',
  PAN = 'PAN',
  PER = 'PER',
  PYF = 'PYF',
  PNG = 'PNG',
  PHL = 'PHL',
  PAK = 'PAK',
  POL = 'POL',
  PCN = 'PCN',
  PRI = 'PRI',
  PSE = 'PSE',
  PRT = 'PRT',
  PLW = 'PLW',
  PRY = 'PRY',
  QAT = 'QAT',
  ROU = 'ROU',
  SRB = 'SRB',
  RUS = 'RUS',
  RWA = 'RWA',
  SAU = 'SAU',
  SLB = 'SLB',
  SYC = 'SYC',
  SDN = 'SDN',
  SWE = 'SWE',
  SGP = 'SGP',
  SHN = 'SHN',
  SVN = 'SVN',
  SVK = 'SVK',
  SLE = 'SLE',
  SMR = 'SMR',
  SEN = 'SEN',
  SOM = 'SOM',
  SUR = 'SUR',
  SSD = 'SSD',
  STP = 'STP',
  SLV = 'SLV',
  SYR = 'SYR',
  SWZ = 'SWZ',
  TCA = 'TCA',
  TCD = 'TCD',
  TGO = 'TGO',
  THA = 'THA',
  TJK = 'TJK',
  TKL = 'TKL',
  TLS = 'TLS',
  TKM = 'TKM',
  TUN = 'TUN',
  TON = 'TON',
  TUR = 'TUR',
  TTO = 'TTO',
  TUV = 'TUV',
  TWN = 'TWN',
  TZA = 'TZA',
  UKR = 'UKR',
  UGA = 'UGA',
  USA = 'USA',
  URY = 'URY',
  UZB = 'UZB',
  VAT = 'VAT',
  VCT = 'VCT',
  VEN = 'VEN',
  VGB = 'VGB',
  VIR = 'VIR',
  VNM = 'VNM',
  VUT = 'VUT',
  WLF = 'WLF',
  WSM = 'WSM',
  XKX = 'XKX',
  YEM = 'YEM',
  MYT = 'MYT',
  ZAF = 'ZAF',
  ZMB = 'ZMB',
  ZWE = 'ZWE',
}

export const Continent = Object.freeze([
  ContinentCode.AS,
  ContinentCode.AF,
  ContinentCode.EU,
  ContinentCode.NA,
  ContinentCode.SA,
  ContinentCode.OC,
]);

export const Regions: readonly {
  continent?: ContinentCode;
  country?: string;
  countryCodes?: string[];
  id: RegionsCode | typeof WorldwideCode;
  image: string;
  isoCode2?: RegionsCode;
  isoCode3?: RegionsIsoCode3;
  isMajor?: boolean;
}[] = Object.freeze([
  {
    continent: ContinentCode.EU,
    country: 'Andorra',
    countryCodes: ['376'],
    id: RegionsCode.AD,
    image: ADRegionImage,
    isoCode2: RegionsCode.AD,
    isoCode3: RegionsIsoCode3.AND,
  },
  {
    continent: ContinentCode.AS,
    country: 'United Arab Emirates',
    countryCodes: ['971'],
    id: RegionsCode.AE,
    image: AERegionImage,
    isoCode2: RegionsCode.AE,
    isoCode3: RegionsIsoCode3.ARE,
  },
  {
    continent: ContinentCode.AS,
    country: 'Afghanistan',
    countryCodes: ['93'],
    id: RegionsCode.AF,
    image: AFRegionImage,
    isoCode2: RegionsCode.AF,
    isoCode3: RegionsIsoCode3.AFG,
  },
  {
    continent: ContinentCode.NA,
    country: 'Antigua and Barbuda',
    countryCodes: ['1-268'],
    id: RegionsCode.AG,
    image: AGRegionImage,
    isoCode2: RegionsCode.AG,
    isoCode3: RegionsIsoCode3.ATG,
  },
  {
    continent: ContinentCode.NA,
    country: 'Anguilla',
    countryCodes: ['1-264'],
    id: RegionsCode.AI,
    image: AIRegionImage,
    isoCode2: RegionsCode.AI,
    isoCode3: RegionsIsoCode3.AIA,
  },
  {
    continent: ContinentCode.EU,
    country: 'Albania',
    countryCodes: ['355'],
    id: RegionsCode.AL,
    image: ALRegionImage,
    isoCode2: RegionsCode.AL,
    isoCode3: RegionsIsoCode3.ALB,
  },
  {
    continent: ContinentCode.AS,
    country: 'Armenia',
    countryCodes: ['374'],
    id: RegionsCode.AM,
    image: AMRegionImage,
    isoCode2: RegionsCode.AM,
    isoCode3: RegionsIsoCode3.ARM,
  },
  {
    continent: ContinentCode.NA,
    country: 'Netherlands Antilles',
    countryCodes: ['599'],
    id: RegionsCode.AN,
    image: ANRegionImage,
    isoCode2: RegionsCode.AN,
    isoCode3: RegionsIsoCode3.ANT,
  },
  {
    continent: ContinentCode.AF,
    country: 'Angola',
    countryCodes: ['244'],
    id: RegionsCode.AO,
    image: AORegionImage,
    isoCode2: RegionsCode.AO,
    isoCode3: RegionsIsoCode3.AGO,
  },
  {
    continent: ContinentCode.AN,
    country: 'Antarctica',
    countryCodes: ['672'],
    id: RegionsCode.AQ,
    image: AQRegionImage,
    isoCode2: RegionsCode.AQ,
    isoCode3: RegionsIsoCode3.ATA,
  },
  {
    continent: ContinentCode.SA,
    country: 'Argentina',
    countryCodes: ['54'],
    id: RegionsCode.AR,
    image: ARRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.AR,
    isoCode3: RegionsIsoCode3.ARG,
  },
  {
    continent: ContinentCode.OC,
    country: 'American Samoa',
    countryCodes: ['1-684'],
    id: RegionsCode.AS,
    image: ASRegionImage,
    isoCode2: RegionsCode.AS,
    isoCode3: RegionsIsoCode3.ASM,
  },
  {
    continent: ContinentCode.EU,
    country: 'Austria',
    countryCodes: ['43'],
    id: RegionsCode.AT,
    image: ATRegionImage,
    isoCode2: RegionsCode.AT,
    isoCode3: RegionsIsoCode3.AUT,
  },
  {
    continent: ContinentCode.OC,
    country: 'Australia',
    countryCodes: ['61'],
    id: RegionsCode.AU,
    image: AURegionImage,
    isMajor: true,
    isoCode2: RegionsCode.AU,
    isoCode3: RegionsIsoCode3.AUS,
  },
  {
    continent: ContinentCode.NA,
    country: 'Aruba',
    countryCodes: ['297'],
    id: RegionsCode.AW,
    image: AWRegionImage,
    isoCode2: RegionsCode.AW,
    isoCode3: RegionsIsoCode3.ABW,
  },
  {
    continent: ContinentCode.EU,
    id: RegionsCode.AX,
    image: AXRegionImage,
  },
  {
    continent: ContinentCode.AS,
    country: 'Azerbaijan',
    countryCodes: ['994'],
    id: RegionsCode.AZ,
    image: AZRegionImage,
    isoCode2: RegionsCode.AZ,
    isoCode3: RegionsIsoCode3.AZE,
  },
  {
    continent: ContinentCode.EU,
    country: 'Bosnia and Herzegovina',
    countryCodes: ['387'],
    id: RegionsCode.BA,
    image: BARegionImage,
    isoCode2: RegionsCode.BA,
    isoCode3: RegionsIsoCode3.BIH,
  },
  {
    continent: ContinentCode.NA,
    country: 'Barbados',
    countryCodes: ['1-246'],
    id: RegionsCode.BB,
    image: BBRegionImage,
    isoCode2: RegionsCode.BB,
    isoCode3: RegionsIsoCode3.BRB,
  },
  {
    continent: ContinentCode.AS,
    country: 'Bangladesh',
    countryCodes: ['880'],
    id: RegionsCode.BD,
    image: BDRegionImage,
    isoCode2: RegionsCode.BD,
    isoCode3: RegionsIsoCode3.BGD,
  },
  {
    continent: ContinentCode.EU,
    country: 'Belgium',
    countryCodes: ['32'],
    id: RegionsCode.BE,
    image: BERegionImage,
    isoCode2: RegionsCode.BE,
    isoCode3: RegionsIsoCode3.BEL,
  },
  {
    continent: ContinentCode.AF,
    country: 'Burkina Faso',
    countryCodes: ['226'],
    id: RegionsCode.BF,
    image: BFRegionImage,
    isoCode2: RegionsCode.BF,
    isoCode3: RegionsIsoCode3.BFA,
  },
  {
    continent: ContinentCode.EU,
    country: 'Bulgaria',
    countryCodes: ['359'],
    id: RegionsCode.BG,
    image: BGRegionImage,
    isoCode2: RegionsCode.BG,
    isoCode3: RegionsIsoCode3.BGR,
  },
  {
    continent: ContinentCode.AS,
    country: 'Bahrain',
    countryCodes: ['973'],
    id: RegionsCode.BH,
    image: BHRegionImage,
    isoCode2: RegionsCode.BH,
    isoCode3: RegionsIsoCode3.BHR,
  },
  {
    continent: ContinentCode.AF,
    country: 'Burundi',
    countryCodes: ['257'],
    id: RegionsCode.BI,
    image: BIRegionImage,
    isoCode2: RegionsCode.BI,
    isoCode3: RegionsIsoCode3.BDI,
  },
  {
    continent: ContinentCode.AF,
    country: 'Benin',
    countryCodes: ['229'],
    id: RegionsCode.BJ,
    image: BJRegionImage,
    isoCode2: RegionsCode.BJ,
    isoCode3: RegionsIsoCode3.BEN,
  },
  {
    continent: ContinentCode.NA,
    country: 'Saint Barthelemy',
    countryCodes: ['590'],
    id: RegionsCode.BL,
    image: BLRegionImage,
    isoCode2: RegionsCode.BL,
    isoCode3: RegionsIsoCode3.BLM,
  },
  {
    continent: ContinentCode.NA,
    country: 'Bermuda',
    countryCodes: ['1-441'],
    id: RegionsCode.BM,
    image: BMRegionImage,
    isoCode2: RegionsCode.BM,
    isoCode3: RegionsIsoCode3.BMU,
  },
  {
    continent: ContinentCode.AS,
    country: 'Brunei',
    countryCodes: ['673'],
    id: RegionsCode.BN,
    image: BNRegionImage,
    isoCode2: RegionsCode.BN,
    isoCode3: RegionsIsoCode3.BRN,
  },
  {
    continent: ContinentCode.SA,
    country: 'Bolivia',
    countryCodes: ['591'],
    id: RegionsCode.BO,
    image: BORegionImage,
    isoCode2: RegionsCode.BO,
    isoCode3: RegionsIsoCode3.BOL,
  },
  {
    continent: ContinentCode.SA,
    country: 'Brazil',
    countryCodes: ['55'],
    id: RegionsCode.BR,
    image: BRRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.BR,
    isoCode3: RegionsIsoCode3.BRA,
  },
  {
    continent: ContinentCode.NA,
    country: 'Bahamas',
    countryCodes: ['1-242'],
    id: RegionsCode.BS,
    image: BSRegionImage,
    isoCode2: RegionsCode.BS,
    isoCode3: RegionsIsoCode3.BHS,
  },
  {
    continent: ContinentCode.AS,
    country: 'Bhutan',
    countryCodes: ['975'],
    id: RegionsCode.BT,
    image: BTRegionImage,
    isoCode2: RegionsCode.BT,
    isoCode3: RegionsIsoCode3.BTN,
  },
  {
    continent: ContinentCode.AF,
    country: 'Botswana',
    countryCodes: ['267'],
    id: RegionsCode.BW,
    image: BWRegionImage,
    isoCode2: RegionsCode.BW,
    isoCode3: RegionsIsoCode3.BWA,
  },
  {
    continent: ContinentCode.EU,
    country: 'Belarus',
    countryCodes: ['375'],
    id: RegionsCode.BY,
    image: BYRegionImage,
    isoCode2: RegionsCode.BY,
    isoCode3: RegionsIsoCode3.BLR,
  },
  {
    continent: ContinentCode.NA,
    country: 'Belize',
    countryCodes: ['501'],
    id: RegionsCode.BZ,
    image: BZRegionImage,
    isoCode2: RegionsCode.BZ,
    isoCode3: RegionsIsoCode3.BLZ,
  },
  {
    continent: ContinentCode.NA,
    country: 'Canada',
    countryCodes: ['1'],
    id: RegionsCode.CA,
    image: CARegionImage,
    isMajor: true,
    isoCode2: RegionsCode.CA,
    isoCode3: RegionsIsoCode3.CAN,
  },
  {
    continent: ContinentCode.AS,
    country: 'Cocos Islands',
    countryCodes: ['61'],
    id: RegionsCode.CC,
    image: CCRegionImage,
    isoCode2: RegionsCode.CC,
    isoCode3: RegionsIsoCode3.CCK,
  },
  {
    continent: ContinentCode.AF,
    country: 'Democratic Republic of the Congo',
    countryCodes: ['243'],
    id: RegionsCode.CD,
    image: CDRegionImage,
    isoCode2: RegionsCode.CD,
    isoCode3: RegionsIsoCode3.COD,
  },
  {
    continent: ContinentCode.AF,
    country: 'Central African Republic',
    countryCodes: ['236'],
    id: RegionsCode.CF,
    image: CFRegionImage,
    isoCode2: RegionsCode.CF,
    isoCode3: RegionsIsoCode3.CAF,
  },
  {
    continent: ContinentCode.AF,
    country: 'Republic of the Congo',
    countryCodes: ['242'],
    id: RegionsCode.CG,
    image: CGRegionImage,
    isoCode2: RegionsCode.CG,
    isoCode3: RegionsIsoCode3.COG,
  },
  {
    continent: ContinentCode.EU,
    country: 'Switzerland',
    countryCodes: ['41'],
    id: RegionsCode.CH,
    image: CHRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.CH,
    isoCode3: RegionsIsoCode3.CHE,
  },
  {
    continent: ContinentCode.AF,
    country: 'Ivory Coast',
    countryCodes: ['225'],
    id: RegionsCode.CI,
    image: CIRegionImage,
    isoCode2: RegionsCode.CI,
    isoCode3: RegionsIsoCode3.CIV,
  },
  {
    continent: ContinentCode.OC,
    country: 'Cook Islands',
    countryCodes: ['682'],
    id: RegionsCode.CK,
    image: CKRegionImage,
    isoCode2: RegionsCode.CK,
    isoCode3: RegionsIsoCode3.COK,
  },
  {
    continent: ContinentCode.SA,
    country: 'Chile',
    countryCodes: ['56'],
    id: RegionsCode.CL,
    image: CLRegionImage,
    isoCode2: RegionsCode.CL,
    isoCode3: RegionsIsoCode3.CHL,
  },
  {
    continent: ContinentCode.AF,
    country: 'Cameroon',
    countryCodes: ['237'],
    id: RegionsCode.CM,
    image: CMRegionImage,
    isoCode2: RegionsCode.CM,
    isoCode3: RegionsIsoCode3.CMR,
  },
  {
    continent: ContinentCode.AS,
    country: 'China',
    countryCodes: ['86'],
    id: RegionsCode.CN,
    image: CNRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.CN,
    isoCode3: RegionsIsoCode3.CHN,
  },
  {
    continent: ContinentCode.SA,
    country: 'Colombia',
    countryCodes: ['57'],
    id: RegionsCode.CO,
    image: CORegionImage,
    isoCode2: RegionsCode.CO,
    isoCode3: RegionsIsoCode3.COL,
  },
  {
    continent: ContinentCode.NA,
    country: 'Costa Rica',
    countryCodes: ['506'],
    id: RegionsCode.CR,
    image: CRRegionImage,
    isoCode2: RegionsCode.CR,
    isoCode3: RegionsIsoCode3.CRI,
  },
  {
    continent: ContinentCode.NA,
    country: 'Cuba',
    countryCodes: ['53'],
    id: RegionsCode.CU,
    image: CURegionImage,
    isoCode2: RegionsCode.CU,
    isoCode3: RegionsIsoCode3.CUB,
  },
  {
    continent: ContinentCode.AF,
    country: 'Cape Verde',
    countryCodes: ['238'],
    id: RegionsCode.CV,
    image: CVRegionImage,
    isoCode2: RegionsCode.CV,
    isoCode3: RegionsIsoCode3.CPV,
  },
  {
    continent: ContinentCode.NA,
    country: 'Curacao',
    countryCodes: ['599'],
    id: RegionsCode.CW,
    image: CWRegionImage,
    isoCode2: RegionsCode.CW,
    isoCode3: RegionsIsoCode3.CUW,
  },
  {
    continent: ContinentCode.AS,
    country: 'Christmas Island',
    countryCodes: ['61'],
    id: RegionsCode.CX,
    image: CXRegionImage,
    isoCode2: RegionsCode.CX,
    isoCode3: RegionsIsoCode3.CXR,
  },
  {
    continent: ContinentCode.AS,
    country: 'Cyprus',
    countryCodes: ['357'],
    id: RegionsCode.CY,
    image: CYRegionImage,
    isoCode2: RegionsCode.CY,
    isoCode3: RegionsIsoCode3.CYP,
  },
  {
    continent: ContinentCode.EU,
    country: 'Czech Republic',
    countryCodes: ['420'],
    id: RegionsCode.CZ,
    image: CZRegionImage,
    isoCode2: RegionsCode.CZ,
    isoCode3: RegionsIsoCode3.CZE,
  },
  {
    continent: ContinentCode.EU,
    country: 'Germany',
    countryCodes: ['49'],
    id: RegionsCode.DE,
    image: DERegionImage,
    isMajor: true,
    isoCode2: RegionsCode.DE,
    isoCode3: RegionsIsoCode3.DEU,
  },
  {
    continent: ContinentCode.AF,
    country: 'Djibouti',
    countryCodes: ['253'],
    id: RegionsCode.DJ,
    image: DJRegionImage,
    isoCode2: RegionsCode.DJ,
    isoCode3: RegionsIsoCode3.DJI,
  },
  {
    continent: ContinentCode.EU,
    country: 'Denmark',
    countryCodes: ['45'],
    id: RegionsCode.DK,
    image: DKRegionImage,
    isoCode2: RegionsCode.DK,
    isoCode3: RegionsIsoCode3.DNK,
  },
  {
    continent: ContinentCode.NA,
    country: 'Dominica',
    countryCodes: ['1-767'],
    id: RegionsCode.DM,
    image: DMRegionImage,
    isoCode2: RegionsCode.DM,
    isoCode3: RegionsIsoCode3.DMA,
  },
  {
    continent: ContinentCode.NA,
    country: 'Dominican Republic',
    countryCodes: ['1-809', '1-829', '1-849'],
    id: RegionsCode.DO,
    image: DORegionImage,
    isoCode2: RegionsCode.DO,
    isoCode3: RegionsIsoCode3.DOM,
  },
  {
    continent: ContinentCode.AF,
    country: 'Algeria',
    countryCodes: ['213'],
    id: RegionsCode.DZ,
    image: DZRegionImage,
    isoCode2: RegionsCode.DZ,
    isoCode3: RegionsIsoCode3.DZA,
  },
  {
    continent: ContinentCode.SA,
    country: 'Ecuador',
    countryCodes: ['593'],
    id: RegionsCode.EC,
    image: ECRegionImage,
    isoCode2: RegionsCode.EC,
    isoCode3: RegionsIsoCode3.ECU,
  },
  {
    continent: ContinentCode.EU,
    country: 'Estonia',
    countryCodes: ['372'],
    id: RegionsCode.EE,
    image: EERegionImage,
    isoCode2: RegionsCode.EE,
    isoCode3: RegionsIsoCode3.EST,
  },
  {
    continent: ContinentCode.AF,
    country: 'Egypt',
    countryCodes: ['20'],
    id: RegionsCode.EG,
    image: EGRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.EG,
    isoCode3: RegionsIsoCode3.EGY,
  },
  {
    continent: ContinentCode.AF,
    country: 'Western Sahara',
    countryCodes: ['212'],
    id: RegionsCode.EH,
    image: EHRegionImage,
    isoCode2: RegionsCode.EH,
    isoCode3: RegionsIsoCode3.ESH,
  },
  {
    continent: ContinentCode.AF,
    country: 'Eritrea',
    countryCodes: ['291'],
    id: RegionsCode.ER,
    image: ERRegionImage,
    isoCode2: RegionsCode.ER,
    isoCode3: RegionsIsoCode3.ERI,
  },
  {
    continent: ContinentCode.EU,
    country: 'Spain',
    countryCodes: ['34'],
    id: RegionsCode.ES,
    image: ESRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.ES,
    isoCode3: RegionsIsoCode3.ESP,
  },
  {
    continent: ContinentCode.AF,
    country: 'Ethiopia',
    countryCodes: ['251'],
    id: RegionsCode.ET,
    image: ETRegionImage,
    isoCode2: RegionsCode.ET,
    isoCode3: RegionsIsoCode3.ETH,
  },
  {
    continent: ContinentCode.EU,
    id: RegionsCode.EU,
    image: EURegionImage,
  },
  {
    continent: ContinentCode.EU,
    country: 'Finland',
    countryCodes: ['358'],
    id: RegionsCode.FI,
    image: FIRegionImage,
    isoCode2: RegionsCode.FI,
    isoCode3: RegionsIsoCode3.FIN,
  },
  {
    continent: ContinentCode.OC,
    country: 'Fiji',
    countryCodes: ['679'],
    id: RegionsCode.FJ,
    image: FJRegionImage,
    isoCode2: RegionsCode.FJ,
    isoCode3: RegionsIsoCode3.FJI,
  },
  {
    continent: ContinentCode.SA,
    country: 'Falkland Islands',
    countryCodes: ['500'],
    id: RegionsCode.FK,
    image: FKRegionImage,
    isoCode2: RegionsCode.FK,
    isoCode3: RegionsIsoCode3.FLK,
  },
  {
    continent: ContinentCode.OC,
    country: 'Micronesia',
    countryCodes: ['691'],
    id: RegionsCode.FM,
    image: FMRegionImage,
    isoCode2: RegionsCode.FM,
    isoCode3: RegionsIsoCode3.FSM,
  },
  {
    continent: ContinentCode.EU,
    country: 'Faroe Islands',
    countryCodes: ['298'],
    id: RegionsCode.FO,
    image: FORegionImage,
    isoCode2: RegionsCode.FO,
    isoCode3: RegionsIsoCode3.FRO,
  },
  {
    continent: ContinentCode.EU,
    country: 'France',
    countryCodes: ['33'],
    id: RegionsCode.FR,
    image: FRRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.FR,
    isoCode3: RegionsIsoCode3.FRA,
  },
  {
    continent: ContinentCode.AF,
    country: 'Gabon',
    countryCodes: ['241'],
    id: RegionsCode.GA,
    image: GARegionImage,
    isoCode2: RegionsCode.GA,
    isoCode3: RegionsIsoCode3.GAB,
  },
  {
    continent: ContinentCode.EU,
    country: 'United Kingdom',
    countryCodes: ['44'],
    id: RegionsCode.GB,
    image: GBRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.GB,
    isoCode3: RegionsIsoCode3.GBR,
  },
  {
    continent: ContinentCode.NA,
    country: 'Grenada',
    countryCodes: ['1-473'],
    id: RegionsCode.GD,
    image: GDRegionImage,
    isoCode2: RegionsCode.GD,
    isoCode3: RegionsIsoCode3.GRD,
  },
  {
    continent: ContinentCode.AS,
    country: 'Georgia',
    countryCodes: ['995'],
    id: RegionsCode.GE,
    image: GERegionImage,
    isoCode2: RegionsCode.GE,
    isoCode3: RegionsIsoCode3.GEO,
  },
  {
    continent: ContinentCode.EU,
    country: 'Guernsey',
    countryCodes: ['44-1481'],
    id: RegionsCode.GG,
    image: GGRegionImage,
    isoCode2: RegionsCode.GG,
    isoCode3: RegionsIsoCode3.GGY,
  },
  {
    continent: ContinentCode.AF,
    country: 'Ghana',
    countryCodes: ['233'],
    id: RegionsCode.GH,
    image: GHRegionImage,
    isoCode2: RegionsCode.GH,
    isoCode3: RegionsIsoCode3.GHA,
  },
  {
    continent: ContinentCode.EU,
    country: 'Gibraltar',
    countryCodes: ['350'],
    id: RegionsCode.GI,
    image: GIRegionImage,
    isoCode2: RegionsCode.GI,
    isoCode3: RegionsIsoCode3.GIB,
  },
  {
    continent: ContinentCode.NA,
    country: 'Greenland',
    countryCodes: ['299'],
    id: RegionsCode.GL,
    image: GLRegionImage,
    isoCode2: RegionsCode.GL,
    isoCode3: RegionsIsoCode3.GRL,
  },
  {
    continent: ContinentCode.AF,
    country: 'Gambia',
    countryCodes: ['220'],
    id: RegionsCode.GM,
    image: GMRegionImage,
    isoCode2: RegionsCode.GM,
    isoCode3: RegionsIsoCode3.GMB,
  },
  {
    continent: ContinentCode.AF,
    country: 'Guinea',
    countryCodes: ['224'],
    id: RegionsCode.GN,
    image: GNRegionImage,
    isoCode2: RegionsCode.GN,
    isoCode3: RegionsIsoCode3.GIN,
  },
  {
    continent: ContinentCode.AF,
    country: 'Equatorial Guinea',
    countryCodes: ['240'],
    id: RegionsCode.GQ,
    image: GQRegionImage,
    isoCode2: RegionsCode.GQ,
    isoCode3: RegionsIsoCode3.GNQ,
  },
  {
    continent: ContinentCode.EU,
    country: 'Greece',
    countryCodes: ['30'],
    id: RegionsCode.GR,
    image: GRRegionImage,
    isoCode2: RegionsCode.GR,
    isoCode3: RegionsIsoCode3.GRC,
  },
  {
    continent: ContinentCode.AN,
    id: RegionsCode.GS,
    image: GSRegionImage,
  },
  {
    continent: ContinentCode.NA,
    country: 'Guatemala',
    countryCodes: ['502'],
    id: RegionsCode.GT,
    image: GTRegionImage,
    isoCode2: RegionsCode.GT,
    isoCode3: RegionsIsoCode3.GTM,
  },
  {
    continent: ContinentCode.OC,
    country: 'Guam',
    countryCodes: ['1-671'],
    id: RegionsCode.GU,
    image: GURegionImage,
    isoCode2: RegionsCode.GU,
    isoCode3: RegionsIsoCode3.GUM,
  },
  {
    continent: ContinentCode.AF,
    country: 'Guinea-Bissau',
    countryCodes: ['245'],
    id: RegionsCode.GW,
    image: GWRegionImage,
    isoCode2: RegionsCode.GW,
    isoCode3: RegionsIsoCode3.GNB,
  },
  {
    continent: ContinentCode.SA,
    country: 'Guyana',
    countryCodes: ['592'],
    id: RegionsCode.GY,
    image: GYRegionImage,
    isoCode2: RegionsCode.GY,
    isoCode3: RegionsIsoCode3.GUY,
  },
  {
    continent: ContinentCode.AS,
    country: 'Hong Kong',
    countryCodes: ['852'],
    id: RegionsCode.HK,
    image: HKRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.HK,
    isoCode3: RegionsIsoCode3.HKG,
  },
  {
    continent: ContinentCode.NA,
    country: 'Honduras',
    countryCodes: ['504'],
    id: RegionsCode.HN,
    image: HNRegionImage,
    isoCode2: RegionsCode.HN,
    isoCode3: RegionsIsoCode3.HND,
  },
  {
    continent: ContinentCode.EU,
    country: 'Croatia',
    countryCodes: ['385'],
    id: RegionsCode.HR,
    image: HRRegionImage,
    isoCode2: RegionsCode.HR,
    isoCode3: RegionsIsoCode3.HRV,
  },
  {
    continent: ContinentCode.NA,
    country: 'Haiti',
    countryCodes: ['509'],
    id: RegionsCode.HT,
    image: HTRegionImage,
    isoCode2: RegionsCode.HT,
    isoCode3: RegionsIsoCode3.HTI,
  },
  {
    continent: ContinentCode.EU,
    country: 'Hungary',
    countryCodes: ['36'],
    id: RegionsCode.HU,
    image: HURegionImage,
    isoCode2: RegionsCode.HU,
    isoCode3: RegionsIsoCode3.HUN,
  },
  {
    continent: ContinentCode.AS,
    country: 'Indonesia',
    countryCodes: ['62'],
    id: RegionsCode.ID,
    image: IDRegionImage,
    isoCode2: RegionsCode.ID,
    isoCode3: RegionsIsoCode3.IDN,
  },
  {
    continent: ContinentCode.EU,
    country: 'Ireland',
    countryCodes: ['353'],
    id: RegionsCode.IE,
    image: IERegionImage,
    isoCode2: RegionsCode.IE,
    isoCode3: RegionsIsoCode3.IRL,
  },
  {
    continent: ContinentCode.AS,
    country: 'Israel',
    countryCodes: ['972'],
    id: RegionsCode.IL,
    image: ILRegionImage,
    isoCode2: RegionsCode.IL,
    isoCode3: RegionsIsoCode3.ISR,
  },
  {
    continent: ContinentCode.EU,
    country: 'Isle of Man',
    countryCodes: ['44-1624'],
    id: RegionsCode.IM,
    image: IMRegionImage,
    isoCode2: RegionsCode.IM,
    isoCode3: RegionsIsoCode3.IMN,
  },
  {
    continent: ContinentCode.AS,
    country: 'India',
    countryCodes: ['91'],
    id: RegionsCode.IN,
    image: INRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.IN,
    isoCode3: RegionsIsoCode3.IND,
  },
  {
    continent: ContinentCode.AS,
    country: 'Iraq',
    countryCodes: ['964'],
    id: RegionsCode.IQ,
    image: IQRegionImage,
    isoCode2: RegionsCode.IQ,
    isoCode3: RegionsIsoCode3.IRQ,
  },
  {
    continent: ContinentCode.AS,
    country: 'Iran',
    countryCodes: ['98'],
    id: RegionsCode.IR,
    image: IRRegionImage,
    isoCode2: RegionsCode.IR,
    isoCode3: RegionsIsoCode3.IRN,
  },
  {
    continent: ContinentCode.EU,
    country: 'Iceland',
    countryCodes: ['354'],
    id: RegionsCode.IS,
    image: ISRegionImage,
    isoCode2: RegionsCode.IS,
    isoCode3: RegionsIsoCode3.ISL,
  },
  {
    continent: ContinentCode.EU,
    country: 'Italy',
    countryCodes: ['39'],
    id: RegionsCode.IT,
    image: ITRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.IT,
    isoCode3: RegionsIsoCode3.ITA,
  },
  {
    continent: ContinentCode.EU,
    country: 'Jersey',
    countryCodes: ['44-1534'],
    id: RegionsCode.JE,
    image: JERegionImage,
    isoCode2: RegionsCode.JE,
    isoCode3: RegionsIsoCode3.JEY,
  },
  {
    continent: ContinentCode.NA,
    country: 'Jamaica',
    countryCodes: ['1-876'],
    id: RegionsCode.JM,
    image: JMRegionImage,
    isoCode2: RegionsCode.JM,
    isoCode3: RegionsIsoCode3.JAM,
  },
  {
    continent: ContinentCode.AS,
    country: 'Jordan',
    countryCodes: ['962'],
    id: RegionsCode.JO,
    image: JORegionImage,
    isoCode2: RegionsCode.JO,
    isoCode3: RegionsIsoCode3.JOR,
  },
  {
    continent: ContinentCode.AS,
    country: 'Japan',
    countryCodes: ['81'],
    id: RegionsCode.JP,
    image: JPRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.JP,
    isoCode3: RegionsIsoCode3.JPN,
  },
  {
    continent: ContinentCode.AF,
    country: 'Kenya',
    countryCodes: ['254'],
    id: RegionsCode.KE,
    image: KERegionImage,
    isoCode2: RegionsCode.KE,
    isoCode3: RegionsIsoCode3.KEN,
  },
  {
    continent: ContinentCode.AS,
    country: 'Kyrgyzstan',
    countryCodes: ['996'],
    id: RegionsCode.KG,
    image: KGRegionImage,
    isoCode2: RegionsCode.KG,
    isoCode3: RegionsIsoCode3.KGZ,
  },
  {
    continent: ContinentCode.AS,
    country: 'Cambodia',
    countryCodes: ['855'],
    id: RegionsCode.KH,
    image: KHRegionImage,
    isoCode2: RegionsCode.KH,
    isoCode3: RegionsIsoCode3.KHM,
  },
  {
    continent: ContinentCode.OC,
    country: 'Kiribati',
    countryCodes: ['686'],
    id: RegionsCode.KI,
    image: KIRegionImage,
    isoCode2: RegionsCode.KI,
    isoCode3: RegionsIsoCode3.KIR,
  },
  {
    continent: ContinentCode.AF,
    country: 'Comoros',
    countryCodes: ['269'],
    id: RegionsCode.KM,
    image: KMRegionImage,
    isoCode2: RegionsCode.KM,
    isoCode3: RegionsIsoCode3.COM,
  },
  {
    continent: ContinentCode.NA,
    country: 'Saint Kitts and Nevis',
    countryCodes: ['1-869'],
    id: RegionsCode.KN,
    image: KNRegionImage,
    isoCode2: RegionsCode.KN,
    isoCode3: RegionsIsoCode3.KNA,
  },
  {
    continent: ContinentCode.AS,
    country: 'North Korea',
    countryCodes: ['850'],
    id: RegionsCode.KP,
    image: KPRegionImage,
    isoCode2: RegionsCode.KP,
    isoCode3: RegionsIsoCode3.PRK,
  },
  {
    continent: ContinentCode.AS,
    country: 'South Korea',
    countryCodes: ['82'],
    id: RegionsCode.KR,
    image: KRRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.KR,
    isoCode3: RegionsIsoCode3.KOR,
  },
  {
    continent: ContinentCode.AS,
    country: 'Kuwait',
    countryCodes: ['965'],
    id: RegionsCode.KW,
    image: KWRegionImage,
    isoCode2: RegionsCode.KW,
    isoCode3: RegionsIsoCode3.KWT,
  },
  {
    continent: ContinentCode.NA,
    country: 'Cayman Islands',
    countryCodes: ['1-345'],
    id: RegionsCode.KY,
    image: KYRegionImage,
    isoCode2: RegionsCode.KY,
    isoCode3: RegionsIsoCode3.CYM,
  },
  {
    continent: ContinentCode.AS,
    country: 'Kazakhstan',
    countryCodes: ['7'],
    id: RegionsCode.KZ,
    image: KZRegionImage,
    isoCode2: RegionsCode.KZ,
    isoCode3: RegionsIsoCode3.KAZ,
  },
  {
    continent: ContinentCode.AS,
    country: 'Laos',
    countryCodes: ['856'],
    id: RegionsCode.LA,
    image: LARegionImage,
    isoCode2: RegionsCode.LA,
    isoCode3: RegionsIsoCode3.LAO,
  },
  {
    continent: ContinentCode.AS,
    country: 'Lebanon',
    countryCodes: ['961'],
    id: RegionsCode.LB,
    image: LBRegionImage,
    isoCode2: RegionsCode.LB,
    isoCode3: RegionsIsoCode3.LBN,
  },
  {
    continent: ContinentCode.NA,
    country: 'Saint Lucia',
    countryCodes: ['1-758'],
    id: RegionsCode.LC,
    image: LCRegionImage,
    isoCode2: RegionsCode.LC,
    isoCode3: RegionsIsoCode3.LCA,
  },
  {
    continent: ContinentCode.EU,
    country: 'Liechtenstein',
    countryCodes: ['423'],
    id: RegionsCode.LI,
    image: LIRegionImage,
    isoCode2: RegionsCode.LI,
    isoCode3: RegionsIsoCode3.LIE,
  },
  {
    continent: ContinentCode.AS,
    country: 'Sri Lanka',
    countryCodes: ['94'],
    id: RegionsCode.LK,
    image: LKRegionImage,
    isoCode2: RegionsCode.LK,
    isoCode3: RegionsIsoCode3.LKA,
  },
  {
    continent: ContinentCode.AF,
    country: 'Liberia',
    countryCodes: ['231'],
    id: RegionsCode.LR,
    image: LRRegionImage,
    isoCode2: RegionsCode.LR,
    isoCode3: RegionsIsoCode3.LBR,
  },
  {
    continent: ContinentCode.AF,
    country: 'Lesotho',
    countryCodes: ['266'],
    id: RegionsCode.LS,
    image: LSRegionImage,
    isoCode2: RegionsCode.LS,
    isoCode3: RegionsIsoCode3.LSO,
  },
  {
    continent: ContinentCode.EU,
    country: 'Lithuania',
    countryCodes: ['370'],
    id: RegionsCode.LT,
    image: LTRegionImage,
    isoCode2: RegionsCode.LT,
    isoCode3: RegionsIsoCode3.LTU,
  },
  {
    continent: ContinentCode.EU,
    country: 'Luxembourg',
    countryCodes: ['352'],
    id: RegionsCode.LU,
    image: LURegionImage,
    isoCode2: RegionsCode.LU,
    isoCode3: RegionsIsoCode3.LUX,
  },
  {
    continent: ContinentCode.EU,
    country: 'Latvia',
    countryCodes: ['371'],
    id: RegionsCode.LV,
    image: LVRegionImage,
    isoCode2: RegionsCode.LV,
    isoCode3: RegionsIsoCode3.LVA,
  },
  {
    continent: ContinentCode.AF,
    country: 'Libya',
    countryCodes: ['218'],
    id: RegionsCode.LY,
    image: LYRegionImage,
    isoCode2: RegionsCode.LY,
    isoCode3: RegionsIsoCode3.LBY,
  },
  {
    continent: ContinentCode.AF,
    country: 'Morocco',
    countryCodes: ['212'],
    id: RegionsCode.MA,
    image: MARegionImage,
    isoCode2: RegionsCode.MA,
    isoCode3: RegionsIsoCode3.MAR,
  },
  {
    continent: ContinentCode.EU,
    country: 'Monaco',
    countryCodes: ['377'],
    id: RegionsCode.MC,
    image: MCRegionImage,
    isoCode2: RegionsCode.MC,
    isoCode3: RegionsIsoCode3.MCO,
  },
  {
    continent: ContinentCode.EU,
    country: 'Moldova',
    countryCodes: ['373'],
    id: RegionsCode.MD,
    image: MDRegionImage,
    isoCode2: RegionsCode.MD,
    isoCode3: RegionsIsoCode3.MDA,
  },
  {
    continent: ContinentCode.EU,
    country: 'Montenegro',
    countryCodes: ['382'],
    id: RegionsCode.ME,
    image: MERegionImage,
    isoCode2: RegionsCode.ME,
    isoCode3: RegionsIsoCode3.MNE,
  },
  {
    continent: ContinentCode.NA,
    country: 'Saint Martin',
    countryCodes: ['590'],
    id: RegionsCode.MF,
    image: MFRegionImage,
    isoCode2: RegionsCode.MF,
    isoCode3: RegionsIsoCode3.MAF,
  },
  {
    continent: ContinentCode.AF,
    country: 'Madagascar',
    countryCodes: ['261'],
    id: RegionsCode.MG,
    image: MGRegionImage,
    isoCode2: RegionsCode.MG,
    isoCode3: RegionsIsoCode3.MDG,
  },
  {
    continent: ContinentCode.OC,
    country: 'Marshall Islands',
    countryCodes: ['692'],
    id: RegionsCode.MH,
    image: MHRegionImage,
    isoCode2: RegionsCode.MH,
    isoCode3: RegionsIsoCode3.MHL,
  },
  {
    continent: ContinentCode.EU,
    country: 'Macedonia',
    countryCodes: ['389'],
    id: RegionsCode.MK,
    image: MKRegionImage,
    isoCode2: RegionsCode.MK,
    isoCode3: RegionsIsoCode3.MKD,
  },
  {
    continent: ContinentCode.AF,
    country: 'Mali',
    countryCodes: ['223'],
    id: RegionsCode.ML,
    image: MLRegionImage,
    isoCode2: RegionsCode.ML,
    isoCode3: RegionsIsoCode3.MLI,
  },
  {
    continent: ContinentCode.AS,
    country: 'Myanmar',
    countryCodes: ['95'],
    id: RegionsCode.MM,
    image: MMRegionImage,
    isoCode2: RegionsCode.MM,
    isoCode3: RegionsIsoCode3.MMR,
  },
  {
    continent: ContinentCode.AS,
    country: 'Mongolia',
    countryCodes: ['976'],
    id: RegionsCode.MN,
    image: MNRegionImage,
    isoCode2: RegionsCode.MN,
    isoCode3: RegionsIsoCode3.MNG,
  },
  {
    continent: ContinentCode.AS,
    country: 'Macau',
    countryCodes: ['853'],
    id: RegionsCode.MO,
    image: MORegionImage,
    isoCode2: RegionsCode.MO,
    isoCode3: RegionsIsoCode3.MAC,
  },
  {
    continent: ContinentCode.OC,
    country: 'Northern Mariana Islands',
    countryCodes: ['1-670'],
    id: RegionsCode.MP,
    image: MPRegionImage,
    isoCode2: RegionsCode.MP,
    isoCode3: RegionsIsoCode3.MNP,
  },
  {
    continent: ContinentCode.NA,
    id: RegionsCode.MQ,
    image: MQRegionImage,
  },
  {
    continent: ContinentCode.AF,
    country: 'Mauritania',
    countryCodes: ['222'],
    id: RegionsCode.MR,
    image: MRRegionImage,
    isoCode2: RegionsCode.MR,
    isoCode3: RegionsIsoCode3.MRT,
  },
  {
    continent: ContinentCode.NA,
    country: 'Montserrat',
    countryCodes: ['1-664'],
    id: RegionsCode.MS,
    image: MSRegionImage,
    isoCode2: RegionsCode.MS,
    isoCode3: RegionsIsoCode3.MSR,
  },
  {
    continent: ContinentCode.EU,
    country: 'Malta',
    countryCodes: ['356'],
    id: RegionsCode.MT,
    image: MTRegionImage,
    isoCode2: RegionsCode.MT,
    isoCode3: RegionsIsoCode3.MLT,
  },
  {
    continent: ContinentCode.AF,
    country: 'Mauritius',
    countryCodes: ['230'],
    id: RegionsCode.MU,
    image: MURegionImage,
    isoCode2: RegionsCode.MU,
    isoCode3: RegionsIsoCode3.MUS,
  },
  {
    continent: ContinentCode.AS,
    country: 'Maldives',
    countryCodes: ['960'],
    id: RegionsCode.MV,
    image: MVRegionImage,
    isoCode2: RegionsCode.MV,
    isoCode3: RegionsIsoCode3.MDV,
  },
  {
    continent: ContinentCode.AF,
    country: 'Malawi',
    countryCodes: ['265'],
    id: RegionsCode.MW,
    image: MWRegionImage,
    isoCode2: RegionsCode.MW,
    isoCode3: RegionsIsoCode3.MWI,
  },
  {
    continent: ContinentCode.NA,
    country: 'Mexico',
    countryCodes: ['52'],
    id: RegionsCode.MX,
    image: MXRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.MX,
    isoCode3: RegionsIsoCode3.MEX,
  },
  {
    continent: ContinentCode.AS,
    country: 'Malaysia',
    countryCodes: ['60'],
    id: RegionsCode.MY,
    image: MYRegionImage,
    isoCode2: RegionsCode.MY,
    isoCode3: RegionsIsoCode3.MYS,
  },
  {
    continent: ContinentCode.AF,
    country: 'Mozambique',
    countryCodes: ['258'],
    id: RegionsCode.MZ,
    image: MZRegionImage,
    isoCode2: RegionsCode.MZ,
    isoCode3: RegionsIsoCode3.MOZ,
  },
  {
    continent: ContinentCode.AF,
    country: 'Namibia',
    countryCodes: ['264'],
    id: RegionsCode.NA,
    image: NARegionImage,
    isoCode2: RegionsCode.NA,
    isoCode3: RegionsIsoCode3.NAM,
  },
  {
    continent: ContinentCode.OC,
    country: 'New Caledonia',
    countryCodes: ['687'],
    id: RegionsCode.NC,
    image: NCRegionImage,
    isoCode2: RegionsCode.NC,
    isoCode3: RegionsIsoCode3.NCL,
  },
  {
    continent: ContinentCode.AF,
    country: 'Niger',
    countryCodes: ['227'],
    id: RegionsCode.NE,
    image: NERegionImage,
    isoCode2: RegionsCode.NE,
    isoCode3: RegionsIsoCode3.NER,
  },
  {
    continent: ContinentCode.OC,
    id: RegionsCode.NF,
    image: NFRegionImage,
  },
  {
    continent: ContinentCode.AF,
    country: 'Nigeria',
    countryCodes: ['234'],
    id: RegionsCode.NG,
    image: NGRegionImage,
    isoCode2: RegionsCode.NG,
    isoCode3: RegionsIsoCode3.NGA,
  },
  {
    continent: ContinentCode.NA,
    country: 'Nicaragua',
    countryCodes: ['505'],
    id: RegionsCode.NI,
    image: NIRegionImage,
    isoCode2: RegionsCode.NI,
    isoCode3: RegionsIsoCode3.NIC,
  },
  {
    continent: ContinentCode.EU,
    country: 'Netherlands',
    countryCodes: ['31'],
    id: RegionsCode.NL,
    image: NLRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.NL,
    isoCode3: RegionsIsoCode3.NLD,
  },
  {
    continent: ContinentCode.EU,
    country: 'Norway',
    countryCodes: ['47'],
    id: RegionsCode.NO,
    image: NORegionImage,
    isoCode2: RegionsCode.NO,
    isoCode3: RegionsIsoCode3.NOR,
  },
  {
    continent: ContinentCode.AS,
    country: 'Nepal',
    countryCodes: ['977'],
    id: RegionsCode.NP,
    image: NPRegionImage,
    isoCode2: RegionsCode.NP,
    isoCode3: RegionsIsoCode3.NPL,
  },
  {
    continent: ContinentCode.OC,
    country: 'Nauru',
    countryCodes: ['674'],
    id: RegionsCode.NR,
    image: NRRegionImage,
    isoCode2: RegionsCode.NR,
    isoCode3: RegionsIsoCode3.NRU,
  },
  {
    continent: ContinentCode.OC,
    country: 'Niue',
    countryCodes: ['683'],
    id: RegionsCode.NU,
    image: NURegionImage,
    isoCode2: RegionsCode.NU,
    isoCode3: RegionsIsoCode3.NIU,
  },
  {
    continent: ContinentCode.OC,
    country: 'New Zealand',
    countryCodes: ['64'],
    id: RegionsCode.NZ,
    image: NZRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.NZ,
    isoCode3: RegionsIsoCode3.NZL,
  },
  {
    continent: ContinentCode.AS,
    country: 'Oman',
    countryCodes: ['968'],
    id: RegionsCode.OM,
    image: OMRegionImage,
    isoCode2: RegionsCode.OM,
    isoCode3: RegionsIsoCode3.OMN,
  },
  {
    continent: ContinentCode.NA,
    country: 'Panama',
    countryCodes: ['507'],
    id: RegionsCode.PA,
    image: PARegionImage,
    isoCode2: RegionsCode.PA,
    isoCode3: RegionsIsoCode3.PAN,
  },
  {
    continent: ContinentCode.SA,
    country: 'Peru',
    countryCodes: ['51'],
    id: RegionsCode.PE,
    image: PERegionImage,
    isoCode2: RegionsCode.PE,
    isoCode3: RegionsIsoCode3.PER,
  },
  {
    continent: ContinentCode.OC,
    country: 'French Polynesia',
    countryCodes: ['689'],
    id: RegionsCode.PF,
    image: PFRegionImage,
    isoCode2: RegionsCode.PF,
    isoCode3: RegionsIsoCode3.PYF,
  },
  {
    continent: ContinentCode.OC,
    country: 'Papua New Guinea',
    countryCodes: ['675'],
    id: RegionsCode.PG,
    image: PGRegionImage,
    isoCode2: RegionsCode.PG,
    isoCode3: RegionsIsoCode3.PNG,
  },
  {
    continent: ContinentCode.AS,
    country: 'Philippines',
    countryCodes: ['63'],
    id: RegionsCode.PH,
    image: PHRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.PH,
    isoCode3: RegionsIsoCode3.PHL,
  },
  {
    continent: ContinentCode.AS,
    country: 'Pakistan',
    countryCodes: ['92'],
    id: RegionsCode.PK,
    image: PKRegionImage,
    isoCode2: RegionsCode.PK,
    isoCode3: RegionsIsoCode3.PAK,
  },
  {
    continent: ContinentCode.EU,
    country: 'Poland',
    countryCodes: ['48'],
    id: RegionsCode.PL,
    image: PLRegionImage,
    isoCode2: RegionsCode.PL,
    isoCode3: RegionsIsoCode3.POL,
  },
  {
    continent: ContinentCode.OC,
    country: 'Pitcairn',
    countryCodes: ['64'],
    id: RegionsCode.PN,
    image: PNRegionImage,
    isoCode2: RegionsCode.PN,
    isoCode3: RegionsIsoCode3.PCN,
  },
  {
    continent: ContinentCode.NA,
    country: 'Puerto Rico',
    countryCodes: ['1-787', '1-939'],
    id: RegionsCode.PR,
    image: PRRegionImage,
    isoCode2: RegionsCode.PR,
    isoCode3: RegionsIsoCode3.PRI,
  },
  {
    continent: ContinentCode.AS,
    country: 'Palestine',
    countryCodes: ['970'],
    id: RegionsCode.PS,
    image: PSRegionImage,
    isoCode2: RegionsCode.PS,
    isoCode3: RegionsIsoCode3.PSE,
  },
  {
    continent: ContinentCode.EU,
    country: 'Portugal',
    countryCodes: ['351'],
    id: RegionsCode.PT,
    image: PTRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.PT,
    isoCode3: RegionsIsoCode3.PRT,
  },
  {
    continent: ContinentCode.OC,
    country: 'Palau',
    countryCodes: ['680'],
    id: RegionsCode.PW,
    image: PWRegionImage,
    isoCode2: RegionsCode.PW,
    isoCode3: RegionsIsoCode3.PLW,
  },
  {
    continent: ContinentCode.SA,
    country: 'Paraguay',
    countryCodes: ['595'],
    id: RegionsCode.PY,
    image: PYRegionImage,
    isoCode2: RegionsCode.PY,
    isoCode3: RegionsIsoCode3.PRY,
  },
  {
    continent: ContinentCode.AS,
    country: 'Qatar',
    countryCodes: ['974'],
    id: RegionsCode.QA,
    image: QARegionImage,
    isoCode2: RegionsCode.QA,
    isoCode3: RegionsIsoCode3.QAT,
  },
  {
    continent: ContinentCode.EU,
    country: 'Romania',
    countryCodes: ['40'],
    id: RegionsCode.RO,
    image: RORegionImage,
    isoCode2: RegionsCode.RO,
    isoCode3: RegionsIsoCode3.ROU,
  },
  {
    continent: ContinentCode.EU,
    country: 'Serbia',
    countryCodes: ['381'],
    id: RegionsCode.RS,
    image: RSRegionImage,
    isoCode2: RegionsCode.RS,
    isoCode3: RegionsIsoCode3.SRB,
  },
  {
    continent: ContinentCode.EU,
    country: 'Russia',
    countryCodes: ['7'],
    id: RegionsCode.RU,
    image: RURegionImage,
    isMajor: true,
    isoCode2: RegionsCode.RU,
    isoCode3: RegionsIsoCode3.RUS,
  },
  {
    continent: ContinentCode.AF,
    country: 'Rwanda',
    countryCodes: ['250'],
    id: RegionsCode.RW,
    image: RWRegionImage,
    isoCode2: RegionsCode.RW,
    isoCode3: RegionsIsoCode3.RWA,
  },
  {
    continent: ContinentCode.AS,
    country: 'Saudi Arabia',
    countryCodes: ['966'],
    id: RegionsCode.SA,
    image: SARegionImage,
    isoCode2: RegionsCode.SA,
    isoCode3: RegionsIsoCode3.SAU,
  },
  {
    continent: ContinentCode.OC,
    country: 'Solomon Islands',
    countryCodes: ['677'],
    id: RegionsCode.SB,
    image: SBRegionImage,
    isoCode2: RegionsCode.SB,
    isoCode3: RegionsIsoCode3.SLB,
  },
  {
    continent: ContinentCode.AF,
    country: 'Seychelles',
    countryCodes: ['248'],
    id: RegionsCode.SC,
    image: SCRegionImage,
    isoCode2: RegionsCode.SC,
    isoCode3: RegionsIsoCode3.SYC,
  },
  {
    continent: ContinentCode.AF,
    country: 'Sudan',
    countryCodes: ['249'],
    id: RegionsCode.SD,
    image: SDRegionImage,
    isoCode2: RegionsCode.SD,
    isoCode3: RegionsIsoCode3.SDN,
  },
  {
    continent: ContinentCode.EU,
    country: 'Sweden',
    countryCodes: ['46'],
    id: RegionsCode.SE,
    image: SERegionImage,
    isoCode2: RegionsCode.SE,
    isoCode3: RegionsIsoCode3.SWE,
  },
  {
    continent: ContinentCode.AS,
    country: 'Singapore',
    countryCodes: ['65'],
    id: RegionsCode.SG,
    image: SGRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.SG,
    isoCode3: RegionsIsoCode3.SGP,
  },
  {
    continent: ContinentCode.AF,
    country: 'Saint Helena',
    countryCodes: ['290'],
    id: RegionsCode.SH,
    image: SHRegionImage,
    isoCode2: RegionsCode.SH,
    isoCode3: RegionsIsoCode3.SHN,
  },
  {
    continent: ContinentCode.EU,
    country: 'Slovenia',
    countryCodes: ['386'],
    id: RegionsCode.SI,
    image: SIRegionImage,
    isoCode2: RegionsCode.SI,
    isoCode3: RegionsIsoCode3.SVN,
  },
  {
    continent: ContinentCode.EU,
    country: 'Slovakia',
    countryCodes: ['421'],
    id: RegionsCode.SK,
    image: SKRegionImage,
    isoCode2: RegionsCode.SK,
    isoCode3: RegionsIsoCode3.SVK,
  },
  {
    continent: ContinentCode.AF,
    country: 'Sierra Leone',
    countryCodes: ['232'],
    id: RegionsCode.SL,
    image: SLRegionImage,
    isoCode2: RegionsCode.SL,
    isoCode3: RegionsIsoCode3.SLE,
  },
  {
    continent: ContinentCode.EU,
    country: 'San Marino',
    countryCodes: ['378'],
    id: RegionsCode.SM,
    image: SMRegionImage,
    isoCode2: RegionsCode.SM,
    isoCode3: RegionsIsoCode3.SMR,
  },
  {
    continent: ContinentCode.AF,
    country: 'Senegal',
    countryCodes: ['221'],
    id: RegionsCode.SN,
    image: SNRegionImage,
    isoCode2: RegionsCode.SN,
    isoCode3: RegionsIsoCode3.SEN,
  },
  {
    continent: ContinentCode.AF,
    country: 'Somalia',
    countryCodes: ['252'],
    id: RegionsCode.SO,
    image: SORegionImage,
    isoCode2: RegionsCode.SO,
    isoCode3: RegionsIsoCode3.SOM,
  },
  {
    continent: ContinentCode.SA,
    country: 'Suriname',
    countryCodes: ['597'],
    id: RegionsCode.SR,
    image: SRRegionImage,
    isoCode2: RegionsCode.SR,
    isoCode3: RegionsIsoCode3.SUR,
  },
  {
    continent: ContinentCode.AF,
    country: 'South Sudan',
    countryCodes: ['211'],
    id: RegionsCode.SS,
    image: SSRegionImage,
    isoCode2: RegionsCode.SS,
    isoCode3: RegionsIsoCode3.SSD,
  },
  {
    continent: ContinentCode.AF,
    country: 'Sao Tome and Principe',
    countryCodes: ['239'],
    id: RegionsCode.ST,
    image: STRegionImage,
    isoCode2: RegionsCode.ST,
    isoCode3: RegionsIsoCode3.STP,
  },
  {
    continent: ContinentCode.NA,
    country: 'El Salvador',
    countryCodes: ['503'],
    id: RegionsCode.SV,
    image: SVRegionImage,
    isoCode2: RegionsCode.SV,
    isoCode3: RegionsIsoCode3.SLV,
  },
  {
    continent: ContinentCode.AS,
    country: 'Syria',
    countryCodes: ['963'],
    id: RegionsCode.SY,
    image: SYRegionImage,
    isoCode2: RegionsCode.SY,
    isoCode3: RegionsIsoCode3.SYR,
  },
  {
    continent: ContinentCode.AF,
    country: 'Swaziland',
    countryCodes: ['268'],
    id: RegionsCode.SZ,
    image: SZRegionImage,
    isoCode2: RegionsCode.SZ,
    isoCode3: RegionsIsoCode3.SWZ,
  },
  {
    continent: ContinentCode.NA,
    country: 'Turks and Caicos Islands',
    countryCodes: ['1-649'],
    id: RegionsCode.TC,
    image: TCRegionImage,
    isoCode2: RegionsCode.TC,
    isoCode3: RegionsIsoCode3.TCA,
  },
  {
    continent: ContinentCode.AF,
    country: 'Chad',
    countryCodes: ['235'],
    id: RegionsCode.TD,
    image: TDRegionImage,
    isoCode2: RegionsCode.TD,
    isoCode3: RegionsIsoCode3.TCD,
  },
  {
    continent: ContinentCode.AN,
    id: RegionsCode.TF,
    image: TFRegionImage,
  },
  {
    continent: ContinentCode.AF,
    country: 'Togo',
    countryCodes: ['228'],
    id: RegionsCode.TG,
    image: TGRegionImage,
    isoCode2: RegionsCode.TG,
    isoCode3: RegionsIsoCode3.TGO,
  },
  {
    continent: ContinentCode.AS,
    country: 'Thailand',
    countryCodes: ['66'],
    id: RegionsCode.TH,
    image: THRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.TH,
    isoCode3: RegionsIsoCode3.THA,
  },
  {
    continent: ContinentCode.AS,
    country: 'Tajikistan',
    countryCodes: ['992'],
    id: RegionsCode.TJ,
    image: TJRegionImage,
    isoCode2: RegionsCode.TJ,
    isoCode3: RegionsIsoCode3.TJK,
  },
  {
    continent: ContinentCode.OC,
    country: 'Tokelau',
    countryCodes: ['690'],
    id: RegionsCode.TK,
    image: TKRegionImage,
    isoCode2: RegionsCode.TK,
    isoCode3: RegionsIsoCode3.TKL,
  },
  {
    continent: ContinentCode.AS,
    country: 'East Timor',
    countryCodes: ['670'],
    id: RegionsCode.TL,
    image: TLRegionImage,
    isoCode2: RegionsCode.TL,
    isoCode3: RegionsIsoCode3.TLS,
  },
  {
    continent: ContinentCode.AS,
    country: 'Turkmenistan',
    countryCodes: ['993'],
    id: RegionsCode.TM,
    image: TMRegionImage,
    isoCode2: RegionsCode.TM,
    isoCode3: RegionsIsoCode3.TKM,
  },
  {
    continent: ContinentCode.AF,
    country: 'Tunisia',
    countryCodes: ['216'],
    id: RegionsCode.TN,
    image: TNRegionImage,
    isoCode2: RegionsCode.TN,
    isoCode3: RegionsIsoCode3.TUN,
  },
  {
    continent: ContinentCode.OC,
    country: 'Tonga',
    countryCodes: ['676'],
    id: RegionsCode.TO,
    image: TORegionImage,
    isoCode2: RegionsCode.TO,
    isoCode3: RegionsIsoCode3.TON,
  },
  {
    continent: ContinentCode.AS,
    country: 'Turkey',
    countryCodes: ['90'],
    id: RegionsCode.TR,
    image: TRRegionImage,
    isoCode2: RegionsCode.TR,
    isoCode3: RegionsIsoCode3.TUR,
  },
  {
    continent: ContinentCode.NA,
    country: 'Trinidad and Tobago',
    countryCodes: ['1-868'],
    id: RegionsCode.TT,
    image: TTRegionImage,
    isoCode2: RegionsCode.TT,
    isoCode3: RegionsIsoCode3.TTO,
  },
  {
    continent: ContinentCode.OC,
    country: 'Tuvalu',
    countryCodes: ['688'],
    id: RegionsCode.TV,
    image: TVRegionImage,
    isoCode2: RegionsCode.TV,
    isoCode3: RegionsIsoCode3.TUV,
  },
  {
    continent: ContinentCode.AS,
    country: 'Taiwan',
    countryCodes: ['886'],
    id: RegionsCode.TW,
    image: TWRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.TW,
    isoCode3: RegionsIsoCode3.TWN,
  },
  {
    continent: ContinentCode.AF,
    country: 'Tanzania',
    countryCodes: ['255'],
    id: RegionsCode.TZ,
    image: TZRegionImage,
    isoCode2: RegionsCode.TZ,
    isoCode3: RegionsIsoCode3.TZA,
  },
  {
    continent: ContinentCode.EU,
    country: 'Ukraine',
    countryCodes: ['380'],
    id: RegionsCode.UA,
    image: UARegionImage,
    isoCode2: RegionsCode.UA,
    isoCode3: RegionsIsoCode3.UKR,
  },
  {
    continent: ContinentCode.AF,
    country: 'Uganda',
    countryCodes: ['256'],
    id: RegionsCode.UG,
    image: UGRegionImage,
    isoCode2: RegionsCode.UG,
    isoCode3: RegionsIsoCode3.UGA,
  },
  {
    continent: ContinentCode.NA,
    country: 'United States',
    countryCodes: ['1'],
    id: RegionsCode.US,
    image: USRegionImage,
    isMajor: true,
    isoCode2: RegionsCode.US,
    isoCode3: RegionsIsoCode3.USA,
  },
  {
    continent: ContinentCode.SA,
    country: 'Uruguay',
    countryCodes: ['598'],
    id: RegionsCode.UY,
    image: UYRegionImage,
    isoCode2: RegionsCode.UY,
    isoCode3: RegionsIsoCode3.URY,
  },
  {
    continent: ContinentCode.AS,
    country: 'Uzbekistan',
    countryCodes: ['998'],
    id: RegionsCode.UZ,
    image: UZRegionImage,
    isoCode2: RegionsCode.UZ,
    isoCode3: RegionsIsoCode3.UZB,
  },
  {
    continent: ContinentCode.EU,
    country: 'Vatican',
    countryCodes: ['379'],
    id: RegionsCode.VA,
    image: VARegionImage,
    isoCode2: RegionsCode.VA,
    isoCode3: RegionsIsoCode3.VAT,
  },
  {
    continent: ContinentCode.NA,
    country: 'Saint Vincent and the Grenadines',
    countryCodes: ['1-784'],
    id: RegionsCode.VC,
    image: VCRegionImage,
    isoCode2: RegionsCode.VC,
    isoCode3: RegionsIsoCode3.VCT,
  },
  {
    continent: ContinentCode.SA,
    country: 'Venezuela',
    countryCodes: ['58'],
    id: RegionsCode.VE,
    image: VERegionImage,
    isoCode2: RegionsCode.VE,
    isoCode3: RegionsIsoCode3.VEN,
  },
  {
    continent: ContinentCode.NA,
    country: 'British Virgin Islands',
    countryCodes: ['1-284'],
    id: RegionsCode.VG,
    image: VGRegionImage,
    isoCode2: RegionsCode.VG,
    isoCode3: RegionsIsoCode3.VGB,
  },
  {
    continent: ContinentCode.NA,
    country: 'U.S. Virgin Islands',
    countryCodes: ['1-340'],
    id: RegionsCode.VI,
    image: VIRegionImage,
    isoCode2: RegionsCode.VI,
    isoCode3: RegionsIsoCode3.VIR,
  },
  {
    continent: ContinentCode.AS,
    country: 'Vietnam',
    countryCodes: ['84'],
    id: RegionsCode.VN,
    image: VNRegionImage,
    isoCode2: RegionsCode.VN,
    isoCode3: RegionsIsoCode3.VNM,
  },
  {
    continent: ContinentCode.OC,
    country: 'Vanuatu',
    countryCodes: ['678'],
    id: RegionsCode.VU,
    image: VURegionImage,
    isoCode2: RegionsCode.VU,
    isoCode3: RegionsIsoCode3.VUT,
  },
  {
    continent: ContinentCode.OC,
    country: 'Wallis and Futuna',
    countryCodes: ['681'],
    id: RegionsCode.WF,
    image: WFRegionImage,
    isoCode2: RegionsCode.WF,
    isoCode3: RegionsIsoCode3.WLF,
  },
  {
    continent: ContinentCode.OC,
    country: 'Samoa',
    countryCodes: ['685'],
    id: RegionsCode.WS,
    image: WSRegionImage,
    isoCode2: RegionsCode.WS,
    isoCode3: RegionsIsoCode3.WSM,
  },
  {
    continent: ContinentCode.EU,
    country: 'Kosovo',
    countryCodes: ['383'],
    id: RegionsCode.XK,
    image: XKRegionImage,
    isoCode2: RegionsCode.XK,
    isoCode3: RegionsIsoCode3.XKX,
  },
  {
    continent: ContinentCode.AS,
    country: 'Yemen',
    countryCodes: ['967'],
    id: RegionsCode.YE,
    image: YERegionImage,
    isoCode2: RegionsCode.YE,
    isoCode3: RegionsIsoCode3.YEM,
  },
  {
    continent: ContinentCode.AF,
    country: 'Mayotte',
    countryCodes: ['262'],
    id: RegionsCode.YT,
    image: YTRegionImage,
    isoCode2: RegionsCode.YT,
    isoCode3: RegionsIsoCode3.MYT,
  },
  {
    continent: ContinentCode.AF,
    country: 'South Africa',
    countryCodes: ['27'],
    id: RegionsCode.ZA,
    image: ZARegionImage,
    isoCode2: RegionsCode.ZA,
    isoCode3: RegionsIsoCode3.ZAF,
  },
  {
    continent: ContinentCode.AF,
    country: 'Zambia',
    countryCodes: ['260'],
    id: RegionsCode.ZM,
    image: ZMRegionImage,
    isoCode2: RegionsCode.ZM,
    isoCode3: RegionsIsoCode3.ZMB,
  },
  {
    continent: ContinentCode.AF,
    country: 'Zimbabwe',
    countryCodes: ['263'],
    id: RegionsCode.ZW,
    image: ZWRegionImage,
    isoCode2: RegionsCode.ZW,
    isoCode3: RegionsIsoCode3.ZWE,
  },
  {
    id: WorldwideCode,
    image: WorldWideRegionImage,
    isMajor: true,
  },
]);
